<script>import { afterNavigate } from "$app/navigation";
import { page } from "$app/stores";
import {
  cfgOptimoveEnabled,
  cfgOptimoveTenantId,
  cfgOptimoveTenantToken
} from "@infinitro/config";
let waitForSdkLoad = void 0;
const logNavigation = () => {
  console.log("optimove afterNavigate", $page);
};
afterNavigate(() => {
  if (!cfgOptimoveEnabled()) {
    console.log("optimove not enabled");
    return;
  }
  const sdk = globalThis.optimoveSDK;
  if (sdk && typeof sdk === "object") {
    logNavigation();
  } else {
    if (waitForSdkLoad) return;
    waitForSdkLoad = setInterval(() => {
      const sdk2 = globalThis.optimoveSDK;
      if (sdk2 && typeof sdk2 === "object") {
        clearInterval(waitForSdkLoad);
        waitForSdkLoad = void 0;
        logNavigation();
      }
    }, 1e3);
  }
});
</script>

<svelte:head>
	{#if cfgOptimoveEnabled()}
		<script
			async
			src="https://sdk.optimove.net/v2/websdk/?tenant_id={cfgOptimoveTenantId()}&tenant_token={cfgOptimoveTenantToken()}"
			onload="initApp()"
		></script>
	{/if}
</svelte:head>
